<div id="app">
  <div class="error-container">
    <div class="error-code"><span>4</span><span>0</span><span>4</span></div>
    <div class="error-title" i18n="@@Error">Error</div>
    <div class="error-message" i18n="@@The requested page could not be found"> The requested page could not be found</div>
    <!--        <div class="error-message" i18n="@@I think you just went to a page that doesn't exist.">I think you just went to a page that doesn't exist.</div>-->
    <div class="error-message "  [routerLink]="'/'" style="z-index: 9999;" >
      <span style="cursor: pointer;" class="link" i18n="@@Return to main page">Return to main page</span>
    </div>

  </div>
</div>
